import dayjs from "dayjs";
export default {
  formatCurrentDateTime(isSplit) {
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let seconds = date.getSeconds();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (minute < 10) {
      minute = "0" + minute;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    if (isSplit == undefined || isSplit) {
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        seconds
      );
    } else {
      return (
        year + "" + month + "" + day + "" + hour + "" + minute + "" + seconds
      );
    }
  },
  formatDate(date) {
    if (!date) {
      date = new Date();
    }
    if (typeof date == "string") {
      let arr = date.split(" ");
      return arr[0];
    }
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    return date.getFullYear() + "-" + month + "-" + day;
  },
  formatCurrentMonth() {
    const date = new Date();
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    return date.getFullYear() + "-" + month;
  },
  formatDateTime(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let seconds = date.getSeconds();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (minute < 10) {
      minute = "0" + minute;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    return (
      date.getFullYear() +
      "-" +
      month +
      "-" +
      day +
      " " +
      hour +
      ":" +
      minute +
      ":" +
      seconds
    );
  },
  formatTime(date) {
    let hour = date.getHours();
    let minute = date.getMinutes();
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (minute < 10) {
      minute = "0" + minute;
    }
    return hour + ":" + minute;
  },
  illegalCharCheck(str) {
    var re = new RegExp("[^a-zA-Z0-9_()\u4e00-\u9fa5]", "i");
    return re.test(str);
  },
  getTimeRange(days) {
    const date = new Date();
    const end = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59
    );
    date.setTime(date.getTime() - 3600 * 1000 * 24 * days);
    const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return [start, end];
  },
  getDateRange(days) {
    const date = new Date();
    const end = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    date.setTime(date.getTime() - 3600 * 1000 * 24 * days);
    const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return [start, end];
  },
  getBeforeDate(n, date) {
    var n = n;
    var d = new Date();
    if (date != undefined) {
      d = date;
    }
    var year = d.getFullYear();
    var mon = d.getMonth() + 1;
    var day = d.getDate();

    if (day <= n) {
      if (mon > 1) {
        mon = mon - 1;
      } else {
        year = year - 1;
        mon = 12;
      }
    }

    d.setDate(d.getDate() - n);
    year = d.getFullYear();
    mon = d.getMonth() + 1;
    day = d.getDate();
    var s =
      year +
      "-" +
      (mon < 10 ? "0" + mon : mon) +
      "-" +
      (day < 10 ? "0" + day : day);
    return s;
  },
  // 计算两个日期距离的天数
  getDistanceDays(startDate, endDate) {
    const startTime = new Date(startDate).getTime();
    const endTime = new Date(endDate).getTime();
    return Math.ceil((endTime - startTime) / (24 * 60 * 60 * 1000));
  },
  validatePassword(password, min, max) {
    if (min == undefined) {
      min = 8;
    }
    if (max == undefined) {
      max = 16;
    }
    // const re = new RegExp(`(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{${min},${max}}`);
    const re =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,16}$/;
    return re.test(password.trim());
  },
  getCurrentOrRestDate(date) {
    date = date || dayjs();
    function addZero(num) {
      if (num < 10 && num > 0) {
        return "0" + num;
      } else return num;
    }
    function getMonths(date, originalDate) {
      originalDate = originalDate || date;
      let daysInMonth = date.daysInMonth();
      let arrDays = [];
      while (daysInMonth) {
        let current = dayjs(
          String(date.$y) + addZero(date.$M + 1) + addZero(daysInMonth)
        );
        arrDays.push({
          planOrFinish: [0, 0],
          date: current.format("YYYY-MM-DD"),
          dZero: addZero(current.$D),
          d: String(current.$D),
          w: String(current.$W),
          notNow: date.$y + date.$M != originalDate.$y + originalDate.$M,
        });
        daysInMonth--;
      }
      return arrDays.reverse();
    }
    function getDaysArrayByMonth(date) {
      const themonth = getMonths(date);
      let lacknum = themonth[0].w;
      if (lacknum != 0) {
        let lastmonth = getMonths(date.add(-1, "months"), date);
        for (let i = 0; i < lacknum; i++) {
          themonth.unshift(lastmonth[lastmonth.length - 1 - i]);
        }
      }
      if (themonth.length < 6 * 7) {
        let little = 6 * 7 - themonth.length;
        let proximo = getMonths(date.add(1, "months"), date);
        for (let i = 0; i < little; i++) {
          themonth.push(proximo[i]);
        }
      }
      return themonth;
    }
    return {
      y: String(date.year()),
      m: addZero(date.month() + 1),
      d: addZero(date.date()),
      ds: getDaysArrayByMonth(date),
      activateDate: dayjs().format("YYYYMMDD"),
      $DATE: date,
    };
  },
  getTimeWithSeconds(time, seconds) {
    const now = new Date();
    const startOfSeconds = new Date(time.getTime() - seconds * 1000);
    const endOfSeconds = new Date(time.getTime() + seconds * 1000);
    return { start: startOfSeconds, end: endOfSeconds };
  },
  getBeforTimeBySeconds(seconds) {
    const now = new Date();
    const beforeDate = new Date(now.getTime() - seconds * 1000);
    return this.formatDateTime(beforeDate);
  },
  getTimeDifferenceInSeconds(startDate, endDate) {
    const startTime = startDate.getTime();
    const endTime = endDate.getTime();
    const diffInMs = Math.abs(endTime - startTime);
    return Math.floor(diffInMs / 1000);
  },
  compareTime(startTime, endTime) {
    if (startTime == null || endTime == null) return -1;
    const date = new Date();
    const [h1, m1] = startTime.split(":").map(Number);
    const [h2, m2] = endTime.split(":").map(Number);
    const startDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      h1,
      m1
    );
    const endDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      h2,
      m2
    );
    if (startDate < endDate) return -1;
    if (startDate > endDate) return 1;
    return 0;
  },
};
